// Mock data for Startup Culture rebrand landing page
export const brandData = {
  before: {
    name: 'Confidential',
    tagline: 'The quiet decks. The whispered term sheets. The brand that started it all.',
    linkedin: 'https://www.linkedin.com/company/confidential-company-page12/',
    logo: 'https://customer-assets-cm19k8pv.emergentagent.net/job_startup-culture/artifacts/46xjzj49_Screenshot%202026-08-03%20at%209.35.50%E2%80%AFAM.png',
  },
  now: {
    name: 'Startup Culture',
    tagline: 'Same signal. Sharper voice. A publication for the people actually shipping it.',
    linkedin: 'https://www.linkedin.com/company/thestartupculture/',
    logo: 'https://customer-assets-cm19k8pv.emergentagent.net/job_startup-culture/artifacts/d6m2g4fx_startup_culture_icon_network_final.png',
  },
};

export const expectItems = [
  {
    num: '01',
    label: 'Weekly',
    title: 'One story, deeply told',
    body: "A single founder, a single chapter. The wins, the spirals, the things they wouldn't say on a podcast.",
    icon: 'BookOpen',
    dark: false,
  },
  {
    num: '02',
    label: 'Verbatim',
    title: 'In their own words',
    body: "Long-form interviews edited for flow, not for sanitization. You'll hear them think.",
    icon: 'Quote',
    dark: true,
  },
  {
    num: '03',
    label: 'Useful',
    title: 'Lessons you can steal',
    body: 'Every issue ends with three tactical takeaways. Save them. Use them. Steal shamelessly.',
    icon: 'Sparkles',
    dark: false,
  },
];

export const pressRelease = {
  headline: '"Confidential announces rebrand to Startup Culture, marking a new editorial direction."',
  summary: "Read the official press release covering the full story behind the rebrand \u2014 what's changing, what's staying, and where we're headed next.",
  source: 'IssueWire',
  url: '#',
};
